import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isNil } from 'ramda';
import { fetchVouchers } from '../state/vouchers';
import { VOUCHER_PROVIDER } from '../constants';

const useVouchers = () => {
  const dispatch = useDispatch();

  const { availableVouchers } = useSelector((state) => state.nomadInsurance.vouchers);

  useEffect(() => {
    if (isNil(availableVouchers)) {
      dispatch(fetchVouchers(VOUCHER_PROVIDER.AIRALO));
    }
  }, [dispatch, availableVouchers]);

  return { availableVouchers };
};

export default useVouchers;
